import NotAuthenticated from '../../components/NotAuthenticated/NotAuthenticated';
import useAuth from '../../hooks/useAuth';
import './ChallengesForm.scss';
import api from '../../js/api';

export default function ChallengesForm() {

    const authenticated = useAuth();
    if (authenticated === false)
        return <NotAuthenticated />;

    // This component is used to create new bingo challenges
    const submit = async (e) => {
        e.preventDefault();
        const f = document.querySelector('.form');

        const title = f.querySelector('#challenge-name').value;
        const desc = f.querySelector('#challenge-desc').value;
        const difficulty = f.querySelector('#challenge-difficulty input:checked').value;

        const challenge = {
            title: title,
            description: desc,
            difficulty: parseInt(difficulty),
            category: 'general',
            points: 100,
            image_required: true,
        }

        const r = await api.post('/user/bingo/challenges', challenge)
        console.log(r);
        if (r.error) {
            alert('Error creating challenge: ' + r.error);
            return;
        }
        alert('Challenge created successfully!');
        f.reset();
        window.location.reload();
    }

    return (
        <div id="challenges-form">
            <div className='centered-container'>
                <br />
                <h1>Challenges Form</h1>
                <br />
                <a href="/bingo/challenges">List Of All Challenges</a>
                <br />
                <p>Create Form</p>
                <form className='form'>
                    <input placeholder='Title' name="challenge-title" id="challenge-name" type="text" required />
                    <input placeholder='Description' name="challenge-desc" id="challenge-desc" type="textarea" required />
                    <br />
                    <label htmlFor="challenge-difficulty">Difficulty</label>
                    <div className='difficulty-options' id="challenge-difficulty">
                        <label>
                            <input type="radio" name="difficulty" value="1" required />
                            1
                        </label>
                        <label>
                            <input type="radio" name="difficulty" value="2" required />
                            2
                        </label>
                        <label>
                            <input type="radio" name="difficulty" value="3" required />
                            3
                        </label>
                        <label>
                            <input type="radio" name="difficulty" value="4" required />
                            4
                        </label>
                        <label>
                            <input type="radio" name="difficulty" value="5" required />
                            5
                        </label>
                    </div>

                    <button type="submit" onClick={submit} className='submit-button'>Submit Challenge</button>
                </form>
            </div>
        </div>
    );
}